module.exports = {
  "acqci-acq-131": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b",
        "variant_c",
        "variant_d"
      ]
    }
  },
  "biab-004": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant"
      ]
    }
  },
  "acq-128": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acq-0133": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "gosu-025b": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant"
      ]
    }
  },
  "gosu-0001": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant"
      ]
    }
  }
};